export const TransactionHistoryStyle = {
  noBorder: {
    border: "none",
    padding: "0px 16px 0px 16px",
    textAlign: "center",
  },
  wrapper: {
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "16px",
    marginY: "16px",
    maxWidth: "100%",
  },
  title: {
    paddingTop: "16px",
    paddingLeft: "16px",
    fontWeight: "bold",
  },
  breadcrumbWrapper: {
    paddingLeft: "16px",
    paddingTop: "16px",
    border: "none",
  },
  tableWrapper: {
    margin: "16px",
    marginTop: "24px",
    height: 600,
    border: "none",
    boxShadow: "none",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  papers: {
    margin: "16px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    maxHeight:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
        ? "85vh"
        : window.innerHeight >= 900
        ? "80vh"
        : "75vh",
    height:
      window.innerHeight >= 1440
        ? "100vh"
        : window.innerHeight >= 1050
        ? "85vh"
        : window.innerHeight >= 900
        ? "80vh"
        : "75vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  noValidate: {
    padding: "16px",
    gap: "20px",
    display: { xs: "block", md: "flex" },
  },

  tableCell: {
    color: "#303131",
    border: "none",
    background: "#F4F6F8",
    fontWeight: "bold",
    textAlign: "center",
  },
  info: {
    padding: "16px",
    border: "none",
    cursor: "pointer",
    color: "#00ab55",
  },
  transactionCell: { padding: "16px", border: "none" },
  cardWrapper: {
    display: { xs: "block", md: "flex" },
    marginX: "8px",
  },
  cardComponent: {
    flex: 1,
  },
  chartComponent: {
    flex: 1,
    display: "flex",
  },
  card: {
    margin: "8px",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
  },
  chart: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  verifyButton: { flex: 1, m: 1, marginTop: "16px" },
  qrButton: { flex: 1, m: 1 },
  box: {
    flex: 1,
    display: "flex",
  },
  paper: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  countWrapper: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    height: "100%",
  },
  count: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  heading: { paddingLeft: "8px", fontWeight: "bold" },
  icon: {
    paddingRight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  noValidate: {
    padding: "16px",
    gap: "20px",
    display: { xs: "block", md: "flex" },
  },
  filter: {
    display: { xs: "flex" },
    mb: { xs: "16px", sm: "auto" },
    width: "100%",
  },
  textField: {
    display: { xs: "flex" },
    mb: { xs: "16px", sm: "auto" },
  },
  customerName: {
    flex: 1,
    display: { xs: "flex" },
  },
  customerUser: {
    "&:hover": {
      backgroundColor: "rgba(0,171,85,0.05)",
      cursor: "default",
      "& > *": {
        // color: theme.palette.primary.main,
      },
    },
  },
  insuranceCarrier: {
    border: "none",
    color: "#00ab55",
    cursor: "pointer",
  },
};
